<main>

	<div class="support">
		<div class="container">

			<h2>Para suas dúvidas, consulte:</h2>
			<a target="blank_" [href]="urlChat" class="btn btn-white">Tire dúvidas online</a>
			<h2>De segunda à sexta-feira, das 8h às 17h30min</h2>

			<form [formGroup]="form">
				<label for="mensagem">Ou envie uma mensagem para nosso suporte</label>
				<textarea name="mensagem" formControlName="mensagem" id="mensagem" placeholder="Mensagem...."></textarea>
				<div class="row justify-content-end">
					<div class="col-auto mb-2 mb-lg-0">
						<select name="assunto" id="assunto" formControlName="tipo">
							<option selected disabled value="">Selecione o assunto</option>
							<option value="1">Dúvida</option>
							<option value="2">Financeiro</option>
							<option value="3">Sugestão</option>
						</select>
					</div>
					<div class="col-auto pl-0">
						<button class="btn btn-white" (click)="enviaMensagem()">Enviar</button>
					</div>
				</div>
			</form>

		</div>
	</div>

	<div class="faq">
		<div class="container">

			<div class="title mb-5">
				<i class="far fa-question-circle"></i>
				<h2>Como podemos te ajudar? (FAQ)</h2>
			</div>

			<!--
			<div class="search w-100 my-5">
				<input type="text" [(ngModel)]="serchText" placeholder="Descreva sua dúvida" class="form-control">
				<button class="btn" (click)="buscarAssunto()"><i class="fas fa-search"></i></button>
			</div>
			-->

			<div class="accordion" id="accordionFaq" filter:serchText>

				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100" data-toggle="collapse" data-target="#secao1">
							Adesão/Inscrição
						</button>
					</div>
					<div id="secao1" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong>Quem é nosso instituidor?</strong></li>
							</ol>
							<p>É a Associação Brasileira de Entidades de Previdência Complementar – ABRAPP é uma entidade sem fins lucrativos, que representa os interesses comuns das Entidades Fechadas de Previdência Complementar.</p>
							<ol start="2">
								<li><strong>Qual a modalidade do plano?</strong></li>
							</ol>
							<p>Contribuição Definida onde os valores das rendas programadas são calculados com base no saldo da conta acumulado pelo participante, ou seja, o valor da renda dependerá de quanto você poupar.</p>
							<ol start="3">
								<li><strong>Posso aderir ao novo plano sem ter o FusanPrev?</strong></li>
							</ol>
							<p>Não. O plano é para os participantes do FusanPrev, ativos e assistidos, e seus parentes.</p>
							<ol start="4">
								<li><strong>Uma pessoa pode ter mais que um plano Viva Mais Previdência em seu nome?</strong></li>
							</ol>
							<p>Não, devido à opção tributária é possível fazer apenas um plano por CPF.</p>
							<ol start="5">
								<li><strong>É possível a adesão on-line?</strong></li>
							</ol>
							<p>Sim. Poderá ser feita através da assinatura em formulário digital disponibilizado pela Fusan.</p>
							<ol start="6">
								<li><strong>Este plano terá um kit de adesão?</strong></li>
							</ol>
							<p>Sim, serão entregues: um certificado, Estatuto da Fusan, Regulamento do Plano e um material explicativo que descreva em linguagem simples as características do Plano.</p>
							<ol start="7">
								<li><strong>Estes documentos (kit de adesão) serão impressos?</strong></li>
							</ol>
							<p>Os documentos estarão disponíveis em meio Eletrônico.</p>
							<ol start="8">
								<li><strong>Quando farei as indicações de meus beneficiários e da minha opção de renda?</strong></li>
							</ol>
							<p>Na inscrição, podendo ser atualizado a qualquer momento, diretamente no site do Viva Mais Previdência.</p>
							<ol start="9">
								<li><strong>Quando terei que definir a idade que irei receber minha renda?</strong></li>
							</ol>
							<p>Na inscrição, porém pode ser alterada de acordo com seu interesse no momento da concessão do benefício.</p>
							<ol start="10">
								<li><strong>Posso indicar alguém para aderir ao Plano? Ou dar o plano de presente para alguém?</strong></li>
							</ol>
							<p>Sim, desde que tenha algum parente que trabalhe ou trabalhou (aposentado ou pensionista) na Sanepar e seja filiado ao FusanPrev</p>
							<ol start="11">
								<li><strong>Quem pode aderir?</strong>
									<ul>
										<li>Cônjuge ou Companheiro, menores sob guarda ou tutela do Participante ou Assistido ou de seus cônjuges/companheiros;</li>
										<li>Parentes em linha reta linha ascendente do associado ou de seu cônjuge/companheiro: 1º grau pais, 2º grau avós, 3º grau bisavós, 4º grau trisavô;</li>
										<li>Parentes em linha reta linha descendente do associado ou de seu cônjuge/companheiro: 1º grau filhos, 2º grau netos, 3º grau bisnetos, 4º grau trinetos;</li>
										<li>Parentes na linha colateral do associado ou de seu cônjuge/companheiro: 2º grau irmãos, 3º grau tios e sobrinhos, 4º grau tios-avós, primos e sobrinhos-netos;</li>
									</ul>
								</li>
							</ol>
							<ol start="12">
								<li><strong>Como comprovar o parentesco?</strong></li>
							</ol>
							<p>&nbsp;A comprovação, do participante ocorrerá por meio de termo declarando que as informações repassadas são verdadeiras ficando sujeitas às verificações e solicitações de documentos pela Fusan a qualquer momento.</p>
							<ol start="13">
								<li><strong>Não tenho documento de união estável, mas estou casado (a) há anos com uma pessoa que tem FusanPrev. Posso aderir?</strong></li>
							</ol>
							<p>Sim, neste caso a comprovação se dará pela declaração do participante titular.</p>
							<ol start="14">
								<li><strong>É preciso assinar a adesão na Abrapp como associado previdenciário? </strong></li>
							</ol>
							<p>Sim, autoriza e assina como associado, porém, não há custo.</p>
							<ol start="15">
								<li><strong>O que é FATCA? Este novo plano precisa de cadastramento de FATCA?</strong></li>
							</ol>
							<p>FATCA é uma Lei de Conformidade Tributária de Contas Estrangeiras que estabelece a obrigatoriedade de instituições bancárias estrangeiras fornecerem dados de seus correntistas às autoridades americanas, desde que esses correntistas sejam também cidadãos norte-americanos. Isso significa que ao aderir a um plano de previdência ou fazer um investimento pessoas que tem cidadania americana, que passaram mais de 31 dias do ano corrente nos Estados Unidos ou possuem conta bancária ou investimentos nos EUA devem registrar esta informação. É importante lembrar que é responsabilidade do participante do plano atualizar esta informação caso exista alguma mudança em seu status</p>
							<p>E sim o novo plano também terá, por se tratar de uma obrigação da Receita Federal que se aplica para todas as entidades e planos.</p>
							<ol start="16">
								<li><strong>O que é PPE? Este plano precisa de cadastramento de PPE?</strong></li>
							</ol>
							<p>PPE – Pessoa Politicamente Exposta é uma declaração exigida das pessoas que ocupam cargos eletivos Isso significa que ao aderir a um plano de previdência ou fazer um investimento pessoas que tem cargos eletivos devem registrar esta informação. É importante lembrar que é responsabilidade do participante do plano atualizar esta informação caso exista uma mudança em seu status</p>
							<p>E sim, esta é uma obrigação legal para todas as entidades e planos previdenciários no Brasil.</p>
						</div>
					</div>
				</div>

				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao2">
							Institutos
						</button>
					</div>
					<div id="secao2" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong>É possível sair do plano portando para outro plano?</strong></li>
							</ol>
							<p>Sim. O Participante que não esteja em gozo do Benefício de Renda Programada e não tenha optado pelo Resgate, poderá optar pela Portabilidade em caso de desligamento do Plano de Benefícios.</p>
							<ol start="2">
								<li><strong>O que é Portabilidade? Quem pode portar para o Viva Mais Previdência?</strong></li>
							</ol>
							<p>É a transferência direta do saldo de um plano PGBL em bancos para o Viva Mais Previdência sem a cobrança de Imposto de Renda.</p>
							<p>Podem portar para o Viva Mais Previdência pessoas que tenham saldo em outros Fundos de Pensão ou aplicações em Bancos na modalidade de PGBL.</p>
							<ol start="3">
								<li><strong>Posso fazer portabilidade de VGBL para o Plano?</strong></li>
							</ol>
							<p>Não, pois o VGBL – Vida Gerador de Benefício Livre é um seguro de vida com cláusula de cobertura por sobrevivência. Ele não é considerado um plano de previdência complementar, pois se enquadra no ramo de seguro de pessoas.</p>
							<ol start="4">
								<li><strong>É possível fazer portabilidade do FusanPrev para o Plano Viva Mais Previdência estando em atividade, trabalhando?</strong></li>
							</ol>
							<p>Não. As regras de saída por portabilidade do FusanPrev continuam sendo de acordo com o regulamento do FusanPrev, ou seja, apenas com a rescisão de contrato.</p>
							<ol start="5">
								<li><strong>É possível fazer aporte no Plano Viva Mais Previdência?</strong></li>
							</ol>
							<p>Sim e a qualquer momento, basta acessar o site do Viva Mais Previdência, definir o valor do aporte, emitir o boleto e pagar na rede bancária.</p>
							<ol start="6">
								<li><strong>Como peço a Portabilidade para o Viva Mais Previdência?</strong></li>
							</ol>
							<p>Assinando requerimento de portabilidade na entidade originária (onde possuo saldo a ser transferido).</p>
							<ol start="7">
								<li><strong>Preciso de algum documento para formalizar a portabilidade?</strong></li>
							</ol>
							<p>Sim, além dos documentos pessoais e do requerimento exigidos pela entidade originária, será emitido também um Termo de Portabilidade.</p>
							<p>&nbsp;</p>
							<ol start="8">
								<li><strong>O que é Termo de Portabilidade?</strong></li>
							</ol>
							<p>É um documento obrigatório legalmente que deve ser emitido pela entidade que possui o valor a ser portado para outra entidade.</p>
							<ol start="9">
								<li><strong>Onde encontro os formulários de portabilidade para o Viva Mais Previdência?</strong></li>
							</ol><p>Os formulários para a portabilidade para o Viva Mais Previdência estão disponíveis no site do Viva Mais Previdência.</p>
							<ol start="10">
								<li><strong>Qual o valor que poderei portar para o Viva Mais Previdência?</strong></li>
							</ol>
							<p>O saldo total será apurado de acordo com a variação patrimonial disponível no dia da efetiva transferência.</p>
							<ol start="11">
								<li><strong>Como funcionará o Autopatrocínio no novo plano?</strong></li>
							</ol>
							<p>Na prática o Autopatrocínio terá função igual à de um participante normal, pois o valor da contribuição continuará a ser o mesmo, bem como, todas as demais características do plano.</p>
							<ol start="12">
								<li><strong>O que é BPD?</strong></li>
							</ol>
							<p>O BPD é a opção que o participante terá ao se desligar do vínculo associativo com o instituidor e permanecer no plano até preencher as carências para o recebimento da Renda Programada. Neste caso, o participante não fará mais contribuições mensais, mas caso queira, poderá realizar aportes de contribuição voluntária. E quando ele preencher as carências poderá solicitar a Renda Programada.</p>
							<ol start="13">
								<li><strong>Como são os resgates do Viva Mais Previdência?</strong></li>
							</ol>
							<p>Existem 2 opções o Resgate total e o Resgate parcial</p>
							<ol start="14">
								<li><strong>O que é o Resgate total?</strong></li>
							</ol>
							<p>É quando o participante resgata todo seu saldo. Para esta opção ele não pode estar em gozo de Benefício de Renda Programada do Plano e precisa fazer o desligamento do Plano de Benefícios.</p>
							<ol start="15">
								<li><strong>Tem alguma carência para o Resgate total?</strong></li>
							</ol>
							<p>Sim, carência de 36 meses de inscrição ao plano para todas as contribuições, contada a partir da data de adesão.</p>
							<ol start="16">
								<li><strong>Então se cancelar o plano posso resgatar tudo? Qual seria este valor?</strong></li>
							</ol>
							<p>Sim, o valor corresponde a 100% (cem por cento) do Saldo Total, e será pago de acordo com o valor disponível.</p>
							<ol start="17">
								<li><strong>E o resgate parcial o que é?</strong></li>
							</ol>
							<p>É a opção de resgatar parcelas do seu saldo de conta, e pode ser feito durante a fase contributiva e sem a obrigatoriedade de seu desligamento do plano.</p>
							<ol start="18">
								<li><strong>Qual a carência para o resgate parcial?</strong></li>
							</ol>
							<p>O prazo de carência será de 36 (trinta e seis) meses da data do último aporte, respeitando o prazo de carência do resgate total.</p>
							<p>Para o 1º resgate parcial a carência é de 36 meses de plano, inclusive para contribuições efetuadas por pessoa jurídica, contada a partir da última contribuição, exceto a Contribuição Básica de Terceiros e a Contribuição Administrativa.</p>
							<p>Após o 1º resgate parcial, a cada 2 anos, faculta-se novamente o resgate parcial até 20% das Contribuições Básicas vertidas pelo participante e 100% das demais contribuições, exceto a Contribuição Básica de Terceiros e Contribuição Administrativa.</p>
							<ol start="19">
								<li><strong>Quais valores posso sacar no resgate parcial?</strong></li>
							</ol>
							<p>Poderão ser resgatados valores:</p>
							<p>– portados na conta do participante e que tenha vindo de entidades abertas ou fechadas de previdência complementar;</p>
							<p>– contribuições voluntárias feitas pelo participante;</p>
							<p>O Participante pode realizar resgates periódicos até 20% das Contribuições Básicas vertidas pelo participante a cada 2 anos.</p>
							<p>Até 100% das Contribuições Voluntárias e dos Recursos Portados, exceto a Contribuição Administrativa e a Contribuição Básica de Terceiros sem precisar se desligar do plano previdenciário.</p>
							<ol start="20">
								<li><strong>Tem algum limite de saque parcial?</strong></li>
							</ol>
							<p>Observado o prazo de carência, o participante poderá a cada dois anos resgatar até 20% (vinte por cento) das contribuições mensais que ele fez, sem a obrigatoriedade de desligamento do plano.</p>
							<ol start="21">
								<li><strong>Eu aderi, fiquei 3 meses no plano e quero sair, posso resgatar tudo? O que acontece, qual minha situação?</strong></li>
							</ol>
							<p>A Lei prevê uma carência de 36 meses para o desligamento total. Resolução CGPC 06/2003, artigo 23º após este período você pode.</p>
							<p>Neste caso você irá cancelar seu vínculo com o plano e levará a 100% (cem por cento) do Saldo Total.</p>
							<ol start="22">
								<li><strong>Qual a documentação para entrada nos institutos?</strong></li>
							</ol>
							<p>A Fusan fornecerá em até no máximo 30 dias a contar da data da cessação do vínculo associativo ou de seu requerimento, um Extrato de Desligamento ao participante que rescindiu com o Instituidor, para auxiliá-lo na sua opção por um dos institutos.</p>
							<p>No prazo de 30 (trinta) dias contados da data do recebimento do extrato o Participante deverá exercer sua opção mediante Termo de Opção em formulário próprio fornecido pela entidade.</p>
							<ol start="23">
								<li><strong>O que acontece se não escolher um instituto dentro deste prazo?</strong></li>
							</ol>
							<p>O participante será transformado em Benefício Proporcional Diferido.</p>
							<ol start="24">
								<li><strong>Qual será a data de pagamento do resgate?</strong></li>
							</ol>
							<p>O pagamento do Resgate será realizado até o último dia útil do mês subsequente ao da formalização da opção em pagamento único ou, a critério do Participante, em até 12 (doze) parcelas mensais e consecutivas, atualizadas pela variação patrimonial.</p>
							
						</div>
					</div>
				</div>

				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao3">
							Cancelamento
						</button>
					</div>
					<div id="secao3" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong>Posso ser cancelado do Viva Mais Previdência?</strong></li>
							</ol>
							<p>-Sim nas seguintes situações</p>
							<p>– Por solicitação;</p><p>– Por falecimento;</p>
							<p>– Por deixar de pagar 3 (três) contribuições mensais consecutivas ou</p>
							<p>– Por deixar de pagar 6 (seis) contribuições alternadas no período de 12 meses;</p>
							<p>– Optar pela Portabilidade;</p>
							<p>– Optar pelo Resgate Total; ou</p>
							<p>– Esgotar o Saldo da Conta de Assistido Contribuição</p>
							<ol start="2">
								<li><strong>Posso voltar para o Viva Mais Previdência após meu cancelamento?</strong></li>
							</ol>
							<p>Sim, para isto se fará necessária uma nova adesão.</p>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao4">
							Contribuição
						</button>
					</div>
					<div id="secao4" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong>Qual o tipo de contribuições terá no plano?</strong></li>
							</ol>
							<p>As Contribuições dos Participantes serão as seguintes:</p>
							<p>Contribuição Mensal obrigatória;</p><p>Contribuição facultativa;</p>
							<p>Contribuição Contratada opcional de Risco por Invalidez Total e Permanente ou Morte.</p>
							<ol start="2">
								<li><strong>O regulamento fala de contribuições voluntárias do participante, o que é isso?</strong></li>
							</ol>
							<p>A Contribuição mensal do Participante será por ele fixada na data de ingresso no Plano, em valor livremente por ele escolhido, observado o mínimo de R$ 50,00 (cinquenta reais).</p>
							<ol start="3">
								<li><strong>O que é a contribuição</strong> <strong>Voluntária, facultativa e esporádica?</strong></li>
							</ol>
							<p>São aquelas de valor livremente escolhido pelo Participante.</p>
							<ol start="4">
								<li><strong>O que é a contribuição</strong> <strong>Contratada de Risco por Invalidez Total e Permanente e/ou Morte por Seguradora?</strong></li>
							</ol>
							<p>Esta contribuição será escolhida pelo Participante ou Assistido, observados os limites técnicos estabelecidos pela Seguradora e servem para a cobertura dos benefícios de risco como invalidez total e permanente ou falecimento, e sua contratação é de caráter facultativo.</p>
							<ol start="5">
								<li><strong>Quais as modalidades de pagamento da contribuição mensal?</strong></li>
							</ol>
							<p>Débito em conta corrente e boleto bancário, além destas opções é possível o desconto em folha de pagamento para aqueles que são empregados da Sanepar.</p>
							<ol start="6">
								<li><strong>Tem valor mínimo para contribuição mensal?</strong></li>
							</ol>
							<p>Sim o valor mínimo é de 50 reais. Este valor terá reajuste anual pela inflação</p>
							<ol start="7">
								<li><strong>A Sanepar também irá contribuir neste novo plano?</strong></li>
							</ol>
							<p>Não.</p>
							<ol start="8">
								<li><strong>Posso alterar a contribuição sempre que desejar?</strong></li>
							</ol>
							<p>Sim, poderá alterar o valor da Contribuição Mensal a qualquer momento, mediante requerimento físico ou digital enviado à Fusan.</p>
							<ol start="9">
								<li><strong>Quando devo efetuar minhas contribuições?</strong></li>
							</ol>
							<p>As contribuições para o plano serão recolhidas através:</p>
							<p>Folha de Pagamento: Somente Empregados ativos</p>
							<p>Folha de Benefícios: Somente Assistidos (Aposentados e Pensionistas Titulares)</p>
							<p>Débito em Conta Corrente: Para todas as categorias titulares e dependentes</p>
							<p>Neste primeiro momento apenas Bancos Itaú</p>
							<p>Boleto Bancário: Para todas as categorias titulares e dependentes</p>
							<ol start="10">
								<li><strong>Posso ficar sem contribuir por um período?</strong></li>
							</ol>
							<p>Sim, o Participante poderá, mediante requerimento, suspender o aporte da Contribuição Mensal para o Plano por no máximo 12 (doze) meses ininterruptos ou não, no período de 60 (sessenta) meses, sem prejuízo da manutenção de sua inscrição.</p>
							<ol start="11">
								<li><strong>No caso de optar por suspender a contribuição mensal, como ficam as contribuições administrativas de risco?</strong></li>
							</ol>
							<p>Durante o período de suspensão o participante compartilhará o custeio das despesas administrativas por meio de um percentual dessa taxa que irá ser descontada do saldo total apurado ao final de cada mês.</p>
							<p>Já a contribuição de risco poderá ser mantida, para que participante ou assistido não perca a cobertura, enquanto suspensa a contribuição mensal.</p>
							<ol start="12">
								<li><strong>Quem venderá os seguros de risco por invalidez e morte?</strong></li>
							</ol>
							<p>A FUSAN contratará junto a uma sociedade seguradora esta cobertura.</p>
							<ol start="13">
								<li><strong>Como farei a adesão para o seguro de risco por invalidez e morte?</strong></li>
							</ol>
							<p>Com assinatura na proposta de inscrição e apresentando a documentação exigida pela seguradora. A aprovação da contratação será realizada pela seguradora</p>
							<ol start="14">
								<li><strong>Terei que pagar para a Fusan ou para a Seguradora?</strong></li>
							</ol>
							<p>A contribuição será feita mensalmente pelo participante à FUSAN, que repassará os valores à Sociedade Seguradora.</p>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao5">
							Renda
						</button>
					</div>
					<div id="secao5" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong>As rendas serão pagas em quantas parcelas? Posso optar por abono anual?</strong></li>
							</ol>
							<p>As rendas serão pagas em 12 (doze parcelas mensais)</p>
							<p>Sim, na data da concessão do benefício o assistido ou beneficiário poderá optar formalmente pelo recebimento do abono anual no mês de dezembro, podendo rever sua opção posteriormente.</p>
							<ol start="2">
								<li><strong>Posso mudar o tipo de recebimento da renda uma vez que já estou recebendo?</strong></li>
							</ol>
							<p>Sim, após a concessão do benefício o assistido ou beneficiário poderá alterar a forma de recebimento do benefício, dentre as formas previstas correspondentes a cada tipo de benefício anualmente, sempre no mês de novembro.</p>
							<ol start="3">
								<li><strong>Como posso alterar a forma de recebimento da minha renda e quando posso fazer a alteração?</strong></li>
							</ol>
							<p>A alteração deverá ser feita no mês de [novembro] de cada ano, para vigorar durante o exercício seguinte.</p>
							<ol start="4">
								<li><strong>Qual a data do pagamento das rendas?</strong></li>
							</ol><p>Os Benefícios serão pagos até o 5º dia útil de cada mês.</p>
							<ol start="5">
								<li><strong>Quando pode haver a extinção do benefício?</strong></li>
							</ol>
							<p>Com a morte do Assistido, se não houver Beneficiário(s);</p>
							<p>Com a morte do Assistido e do(s) Beneficiário(s);</p>
							<p>Com o fim do seu saldo.</p>
							<ol start="6">
								<li><strong>O Viva Mais Previdência terá recadastramento/prova de vida?</strong></li>
							</ol>
							<p>Sim, e o Assistido, sob pena de suspensão do benefício, deverá apresentar comprovante de vida na forma e no prazo definido pela Fusan.</p>
							<ol start="7">
								<li><strong>E se com o falecimento do Assistido não existir beneficiários indicados?</strong></li>
							</ol>
							<p>Neste caso o saldo remanescente da Conta de Assistido será destinado aos herdeiros legais mediante a apresentação de documento judicial pertinente.</p>			
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao6">
							Renda programada
						</button>
					</div>
					<div id="secao6" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong>Qual a carência para me aposentar, ou sair em renda programada?</strong></li>
							</ol>
							<p>12 (doze) meses de vinculação ao Plano e 18 anos de idade.</p>
							<ol start="2">
								<li><strong>Como será calculada a renda programada?</strong></li>
							</ol>
							<p>Será calculado com base no Saldo Total, conforme definição formal do Participante, na data do requerimento do benefício.</p>
							<ol start="3">
								<li><strong>Quais os tipos de renda?</strong></li>
							</ol>
							<p><u>– Renda por prazo certo:</u> calculada pela transformação do Saldo Total em renda mensal, a ser paga pelo prazo certo de no mínimo 1 (um) ano; O prazo será definido pelo participante<u>;</u></p>
							<p><u>– Renda pela expectativa de vida:</u> calculada pela transformação do Saldo Total em renda mensal, a ser paga por prazo determinado com base na expectativa de vida do Participante na data do cálculo, mediante um Fator Atuarial Equivalente;</p>
							<p><u>– Renda por percentual do Saldo Total:</u> calculada pela aplicação de um percentual de, no máximo 1,5% (um e meio por cento) do Saldo Total, a ser paga enquanto houver saldo. A escolha do percentual é responsabilidade do participante.</p>
							<ol start="4">
								<li><strong>No Viva Mais Previdência posso resgatar 20% à vista?</strong></li>
							</ol>
							<p>Sim, no momento do requerimento do benefício o Participante ou Beneficiário poderá fazer esta opção em pagamento único, sendo o valor restante transformado em benefícios conforme sua escolha.</p>
							<ol start="5">
								<li><strong>O Viva Mais Previdência tem um valor mínimo de benefício?</strong></li>
							</ol>
							<p>Sim, se a qualquer momento, inclusive na concessão, o valor gerado por qualquer um dos benefícios do regulamento for uma renda inferior à Unidade Previdenciária Fusan -UPF (em 1/09/2019 é R$ 200,00 (duzentos reais) e será reajustada anualmente, no mês de agosto, pela variação do INPC), o Saldo Total ou saldo remanescente será pago em parcela única ao Participante, Assistido ou Beneficiário, extinguindo-se, após o pagamento, todas as obrigações deste plano perante estes.</p>
							<ol start="6">
								<li><strong>Como fica no caso de contratar o plano para um filho menor?</strong></li>
							</ol>
							<p>Neste caso a Renda Mensal será pago ao seu representante legal.</p>
							<ol start="7">
								<li><strong>Posso usar o Viva Mais Previdência como preferir? Faculdade, comprar carro ou como quiser?</strong></li>
							</ol>
							<p>Sim. Para isto, a escolha da renda ou resgate deverá ser realizada de forma que atenda sua necessidade.</p>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao7">
							Benefícios de Risco
						</button>
					</div>
					<div id="secao7" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<p>1<strong>.&nbsp; Este plano terá pensão?</strong></p>
							<p>Sim, a Renda por Morte será concedida aos Beneficiários do Participante ou Assistido que vier a falecer, e que possuía saldo em conta.</p>
							<p>2. <strong>Quem pode receber a pensão por morte?</strong></p>
							<p>Beneficiários do Participante ou Assistido que vier a falecer e que tenham sido indicados na ficha de inscrição.</p>
							<p>3.<strong> A concessão da pensão por morte tem algum vínculo com o INSS?</strong></p>
							<p>Não, a definição se dará de acordo com regras do regulamento no novo plano.</p>
							<p>4.<strong> Pode incluir beneficiário na ficha do participante após seu falecimento?</strong></p>
							<p>Não, a indicação só poderá ser feita enquanto o participante estiver vivo.</p>
							<p>5. <strong>Qual a forma do cálculo da pensão por morte?</strong></p>
							<p>O participante ou assistido poderá ter contratado parcela adicional de risco junto à Cia. Seguradora. O cálculo da Renda por Morte será realizado considerando o Saldo Total mais o Capital Segurado contratado.</p>
							<p>6.<strong> Quais as opções de recebimento da pensão por morte?</strong></p>
							<p><u>Renda por prazo certo:</u>&nbsp;calculada pela transformação do Saldo Total mais o Capital Segurado aportado pela Seguradora, com pagamento de no mínimo 1 (um) ano;</p>
							<p><u>Renda pela expectativa de vida:</u>&nbsp;calculada pela transformação do Saldo Total mais o Capital Segurado aportado pela Seguradora, com pagamento por prazo determinado com base na expectativa de vida do Participante na data do cálculo, mediante Fator Atuarial;</p>
							<p><u>Renda por percentual do Saldo Total:</u>&nbsp;calculada pela aplicação de um percentual de, no máximo 1,5% (um e meio por cento) do Saldo Total mais o Capital Segurado aportado pela Seguradora, a ser paga enquanto houver saldo.</p>
							<p>7.<strong> Se ocorrer a morte do Assistido e ainda existir saldo o que acontecerá?</strong></p>
							<p>Neste caso, o Benefício de Renda será revertido em favor dos Beneficiários, respeitado o percentual indicado pelo participante, e a forma de pagamento será facultada aos beneficiários, conforme previsto no regulamento.</p>
							<p>a) Se houver beneficiários: o saldo remanescente pode gerar uma nova renda se for maior do que a Unidade Previdenciária Fusan, a aposentadoria será transformada em pensão, com opção de resgate do saldo remanescente.</p>
							<p>b) Se não houver herdeiros: artigo 46, parágrafo único. Devolve-se o saldo remanescente aos herdeiros legais mediante documentação judicial pertinente.</p>
							<p>8.<strong> O Viva Mais Previdência terá renda por invalidez?</strong></p>
							<p>Sim, será concedido ao participante que tiver optado pela parcela da Contratação de Risco de Invalidez Total e Permanente e deverá atender aos critérios previstos no regulamento.</p>
							<p>9.<strong> Como será a comprovação da invalidez total e permanente?</strong></p>
							<p>Ela se dará pela apresentação da carta de concessão da Aposentadoria por Invalidez emitida pela Previdência Oficial – INSS ou laudo de uma junta médica composta por médicos da Fusan e Seguradora.</p>
							<p>10. <strong>Em caso de invalidez no período da carência da renda programada, como fica meu caso?</strong></p>
							<p>Se a invalidez for comprovada pelo recebimento do benefício junto à Previdência Social pelo o Saldo Total, deverá ser pago à vista em quota única.</p>
							<p>a) Se houver contratação da parcela adicional de risco junto à Seguradora, a renda passa a ser a de invalidez, observando os procedimentos de comprovação da mesma;</p>
							<p>b) Se não houver opção de parcela adicional de risco junto à Seguradora, pode transformar em renda programada de acordo com as opções de cálculo do Regulamento ou ainda resgatar o saldo.</p>
							<p>11. <strong>Como será o cálculo da renda por invalidez?</strong></p>
							<p>O participante terá que ter contratado o risco e seu benefício será calculado com base no Saldo Total adicionado ao Capital Segurado aportado pela Seguradora</p>
							<p>12.<strong> Existe apenas uma forma de pagamento da renda por invalidez?</strong></p>
							<p>Não, o participante deverá optar entre:</p>
							<p><u>&nbsp;– Renda por prazo certo:</u>&nbsp;calculada pela transformação do Saldo Total mais o Capital Segurado aportado pela Seguradora, com pagamento mínimo 1 (um) ano;</p>
							<p><u>– Renda pela expectativa de vida:</u>&nbsp;calculada pela transformação do Saldo Total mais o Capital Segurado aportado pela Seguradora, com pagamento determinado com base na expectativa de vida do Participante na data do cálculo, mediante um Fator Atuarial;</p>
							<p><u>– Renda por percentual do Saldo Total</u>: calculada pela aplicação de um percentual de, no máximo 1,5% (um e meio por cento) do Saldo Total adicionado ao Capital Segurado aportado pela Seguradora, a ser paga enquanto houver saldo.</p>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao8">
							Rentabilidade/Investimento
						</button>
					</div>
					<div id="secao8" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong>Como acompanho os dados como rentabilidade mensalmente?</strong></li>
							</ol>
							<p>Através do autoatendimento disponível neste site.</p>
							<ol start="2">
								<li><strong>A cota é diária?</strong></li>
							</ol>
							<p>Será possível acompanhar a variação diária, mas o valor da rentabilidade patrimonial será apurado mensalmente e a sua variação será determinada pela rentabilidade líquida alcançada com a aplicação dos recursos.</p>
							<ol start="3">
								<li><strong>Este plano tem taxa de carregamento na contribuição?</strong></li>
							</ol>
							<p>Apesar de estar prevista em Regulamento, não há cobrança de taxa de carregamento neste momento, porém, poderá ocorrer futuramente.</p>
							<ol start="4">
								<li><strong>E a taxa de administração?</strong></li>
							</ol>
							<p>Sim, A Taxa de Administração incidirá sobre o Saldo Total e será deduzida mensalmente do saldo do participante.</p>
							<ol start="5">
								<li><strong>Onde posso encontrar as taxas de administração</strong> <strong>que estão sendo cobradas?</strong></li>
							</ol>
							<p>A taxa do Viva Mais Previdência aprovada para o ano de 2020 é de 1% do saldo dos fundos em 31/12/2019 o que equivale a uma taxa mensal de 0,083%.</p>
							<ol start="6">
								<li><strong>A política de investimentos do plano é a mesma do FusanPrev?</strong></li>
							</ol>
							<p>Não, o novo plano terá uma política de investimentos própria.</p>
							<ol start="7">
								<li><strong>Onde o meu dinheiro será aplicado?</strong></li>
							</ol>
							<p>De acordo com a Resolução do CMN nº 4.661/2018, os recursos do Viva Mais Previdência poderão ser aplicados em fundos de Renda Fixa, Renda Variável e Multimercados que atendam aos critérios qualitativos e quantitativos definidos na Política de Investimentos do plano, aprovada pelo Conselho Deliberativo da FUSAN.</p>
							<ol start="8">
								<li><strong>Quem decidirá onde os recursos serão aplicados?</strong></li>
							</ol>
							<p>Conforme as diretrizes de investimentos aprovada na Política de Investimentos pelo Conselho Deliberativo, compete à Gerência de Investimentos propor as aplicações dos recursos e ao Comitê de Investimentos assessorar a tomada de decisão da Diretoria Executiva da FUSAN.</p>
							<ol start="9">
								<li><strong>A rentabilidade será a mesma do FUSANPREV?</strong></li>
							</ol>
							<p>Não. O plano Viva Mais Previdência terá uma carteira de investimentos diferenciada do FusanPrev e consequentemente sua rentabilidade não será a mesma, porém, o retorno obtido no FusanPrev demonstra a excelente capacidade que a FUSAN tem, como administradora de planos, de superar as expectativas de rendimento enfrentando os mais diversos cenários econômicos e políticos desde 2001.</p>
							<ol start="10">
								<li><strong>Este plano terá empréstimo para os participantes?</strong></li>
							</ol>
							<p>Não no início. Futuramente será possível de acordo com o volume de recursos que o plano possuir.</p>
							<ol start="11">
								<li><strong>O que é UPF?</strong></li>
							</ol>
							<p>É a Unidade Previdenciária Fusan será utilizada como referencial mínimo mensal dos</p>
							<p>Benefícios oferecidos no Plano, com valor inicial de R$ 200,00 (duzentos reais) em [1º de setembro de 2019] e será reajustada anualmente, no mês de [agosto], pela variação do INPC – Índice Nacional de Preços ao Consumidor/IBGE.</p>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao9">
							Imposto de Renda/Regime Tributário
						</button>
					</div>
					<div id="secao9" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong>Posso abater minhas contribuições do novo plano do meu imposto de renda?</strong></li>
							</ol>
							<p>Sim, sendo que mensalmente não há limite e anualmente podendo ser até no máximo 12% do valor total de verbas recebidas.</p>
							<ol start="2">
								<li><strong>Este plano tem opção pelo regime tributário progressivo ou regressivo? </strong></li>
							</ol>
							<p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Sim, ao realizar uma nova adesão o regime deverá ser escolhido.</p>
							<ol start="3">
								<li><strong>Como funciona o regime progressivo e regressivo?</strong></li>
							</ol>
							<p>No Regime Progressivo a tributação é aplicada de acordo com a faixa de renda mensal, ou seja, quanto maior for sua renda maior será o desconto do imposto. Sendo que há faixa isenta e o limite máximo da alíquota é de 27,5%, podendo haver ajuste anual.</p>
							<p>No Regime Regressivo a tributação é de acordo com o tempo de contribuição no plano, ou seja, quanto mais tempo menor a alíquota. Não há faixa isenta e a alíquota mínima é de 10% e a máxima é 35%. Não há ajuste anual.</p>
							<ol start="4">
								<li><strong>Qual a melhor opção?</strong></li>
							</ol>
							<p>A escolha é pessoal e deve ser feita após análise de suas expectativas futuras de renda.</p>
							<ol start="5">
								<li><strong>Posso mudar a opção ao longo do tempo?</strong></li>
							</ol>
							<p>Não, a escolha é feita na adesão ao plano e não poderá ser alterada.</p>
							<ol start="6">
								<li><strong>Minha opção pode ser diferente do FusanPrev?</strong></li>
							</ol>
							<p>Sim, devido o Viva Mais Previdência ser um plano separado haverá a necessidade de nova opção.</p>
							<ol start="7">
								<li><strong>Se eu fizer adesão de 3 dependentes, a opção do regime tributário será a mesma para os três ou cada um terá que fazer a opção?</strong></li>
							</ol>
							<p>A opção será realizada por CPF, ou seja, uma opção por CPF.</p>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao10">
							Taxa de juros
						</button>
					</div>
					<div id="secao10" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong>Como posso saber qual a taxa de juros que o Viva Mais Previdência adota?</strong></li>
							</ol>
							<p>A taxa de juros, bem como a rentabilidade alcançada será divulgada no site.</p>
							<ol start="2">
								<li><strong>A taxa de juros do Viva Mais Previdência para remuneração das minhas contribuições é fixa?</strong></li>
							</ol>
							<p>Não há taxa de juros contratada para a remuneração das contribuições. A rentabilidade será resultado dos investimentos do Plano. Para saber quais investimentos são realizados consulte a Política de Investimentos disponível no site do Viva Mais Previdência.</p>
							<ol start="3">
								<li><strong>A taxa de juros para cálculo do benefício por expectativa de vida será fixa, sempre a mesma?</strong></li>
							</ol>
							<p>Não a taxa varia em função de estudos técnicos e é atualizada anualmente</p>
							<ol start="4">
								<li><strong>O que é a taxa informada na simulação dos benefícios que está no site?</strong></li>
							</ol>
							<p>É uma expectativa de retorno dos investimentos considerando as oportunidades de investimentos disponíveis naquele momento. Esta taxa pode variar. Não há rentabilidade fixa contratada. A rentabilidade será resultado do retorno dos investimentos realizados pelo plano</p>
						</div>
					</div>
				</div>
				<div class="card">
					<div class="card-header p-0">
						<button class="btn btn-block text-left w-100 collapsed" data-toggle="collapse" data-target="#secao11">
							Sucessão
						</button>
					</div>
					<div id="secao11" class="collapse" data-parent="#accordionFaq">
						<div class="card-body text-left">
							<ol>
								<li><strong> No caso do falecimento do participante titular se os dependentes quiserem resgatar os valores haverá a aplicação de ITCMD? Que impostos incidem no resgate?</strong></li>
							</ol>
							<p>Pelo fato do valor envolvido não ser enquadrado como herança, não é cabível a incidência do ITCMD. O imposto a incidir sobre o montante acumulado pelo participante é o Imposto de Renda.</p>
							<ol start="2">
								<li><strong>Os valores acumulados no Viva Mais Previdência farão parte do inventário caso o participante titular faleça?</strong></li>
							</ol>
							<p>Não. Considerando que o valor acumulado pelo participante não configura uma “aplicação financeira”, pois sua natureza jurídica é análoga ao seguro de pessoas, o valor acumulado pelo participante não integrará o acervo hereditário.</p>
							<ol start="3">
								<li><strong>Para resgatar os valores acumulados no Viva Mais Previdência, no caso de falecimento do titular os dependentes terão que aguardar o fim do inventário? O valor pode ser dividido com dependentes que não estavam definidos como beneficiários no Viva Mais Previdência?</strong></li>
							</ol>
							<p>Não. Não há que se falar em inventário, pois o falecimento do participante não acarreta na transmissão de bem ou direito, mas sim na extinção do benefício de complementação de aposentadoria, fazendo com que uma nova obrigação nasça entre a Entidade Fechada de Previdência Complementar – EFPC e o Beneficiário inscrito no plano de previdência.</p>
							<p>O valor será dividido somente entre os beneficiários previamente inscritos no Plano Previdenciário VIVA MAIS PREVIDÊNCIA.</p>
							<ol start="4">
								<li><strong>Que documentos os beneficiários devem apresentar para resgatar ou transformar em renda o valor acumulado no Viva Mais Previdência em caso de falecimento do participante titular?</strong></li>
							</ol>
							<p>Os documentos que deverão ser apresentados pelos beneficiários são:</p>
							<ol>
								<li>documentos pessoais com foto;</li>
								<li>comprovante de residência atual e</li>
								<li>certidão de óbito do participante.</li>
							</ol>
						</div>
					</div>
				</div>				

			</div>

		</div>
	</div>

</main>